// extracted by mini-css-extract-plugin
export default {"root":"AddToBagVariantOption-module-root-O70E3","disabled":"AddToBagVariantOption-module-disabled-zsXjB"};